import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Terms() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-white">
        <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            SOCIAL TRIP 利用規約
          </h1>
          <p className="text-sm text-gray-500 mb-10">Draft</p>

          <p className="text-gray-700 leading-relaxed mb-8">
            本利用規約（以下「本規約」）は、Force Agent合同会社（以下「当社」）が提供するアプリケーション「SOCIAL TRIP」（以下「本サービス」）の利用条件を定めるものです。本サービスを利用される方（以下「ユーザー」）は、本規約に同意のうえご利用ください。
          </p>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第1条（適用）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。</li>
              <li>当社は本サービスに関し、本規約のほか、利用ガイドライン等を定めることがあります。これらは本規約の一部を構成するものとします。</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第2条（利用登録）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>本サービスの利用を希望する者は、本規約に同意のうえ、当社の定める方法により登録を申請するものとします。</li>
              <li>当社は、登録申請者に以下の事由があると判断した場合、利用登録を承認しないことがあります。
                <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                  <li>(1) 虚偽の事項を届け出た場合</li>
                  <li>(2) 過去に本規約違反があった場合</li>
                  <li>(3) その他当社が不適切と判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第3条（アカウント管理）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>ユーザーは自己の責任においてアカウントを管理するものとします。</li>
              <li>アカウントの不正利用によって生じた損害について、当社は一切責任を負いません。</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第4条（禁止事項）</h2>
            <p className="text-gray-700 leading-relaxed mb-4">ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。</p>
            <ol className="list-decimal list-inside space-y-1 text-gray-700 leading-relaxed">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>他のユーザーまたは第三者の知的財産権、プライバシー権等を侵害する行為</li>
              <li>本サービスの運営を妨害する行為</li>
              <li>商業目的での無断利用、データ収集行為</li>
              <li>不正アクセスや情報改ざん行為</li>
              <li>当社が不適切と判断する行為</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第5条（本サービスの提供）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>当社は、ユーザーに対し以下のサービスを提供します。
                <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                  <li>(1) AIプランナーによる旅行計画提案</li>
                  <li>(2) 旅のしおり作成・共有機能</li>
                  <li>(3) 人気旅行プラン閲覧機能</li>
                  <li>(4) 航空券・ホテル・イベント情報提供（外部サービス連携含む）</li>
                  <li>(5) SOS/セーフティアラートによる災害情報通知</li>
                  <li>(6) その他当社が定める旅行関連サービス</li>
                </ul>
              </li>
              <li>本サービスの一部は有料プランにて提供されます。詳細は別途定める料金表によります。</li>
              <li>外部API・提携サービスを利用する場合、当該サービスの規約が優先して適用される場合があります。</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第6条（有料サービス）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>本サービスには無料プランおよび有料プラン（スタンダードプラン、プロプラン）が存在します。</li>
              <li>ユーザーはアプリ内課金を通じて有料プランを契約するものとします。</li>
              <li>支払いはApp Storeの規約に従って処理されます。</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第7条（免責事項）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>当社は、本サービスに関して、以下について一切の責任を負いません。
                <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                  <li>(1) 提供情報の正確性・完全性・有用性</li>
                  <li>(2) ユーザー間または第三者とのトラブル</li>
                  <li>(3) 通信環境や端末環境による不具合</li>
                  <li>(4) 天災、災害、その他不可抗力による利用停止</li>
                </ul>
              </li>
              <li>本サービス内の航空券・ホテル・イベント予約等は外部サービスを通じて提供されるため、当社は取引に関して責任を負いません。</li>
              <li>SOS/セーフティアラートは外部データ（GDACS等）を基に配信されるため、その正確性・即時性を保証しません。</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第8条（サービスの停止・終了）</h2>
            <p className="text-gray-700 leading-relaxed mb-2">当社は、以下の場合にユーザーへの事前通知なく本サービスを停止・終了できるものとします。</p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 leading-relaxed ml-4">
              <li>(1) システム保守や障害対応のとき</li>
              <li>(2) 天災地変、停電、通信障害等により提供が困難なとき</li>
              <li>(3) 運営上やむを得ない事情があるとき</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第9条（知的財産権）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>本サービスに関する著作権、商標権その他一切の知的財産権は当社または正当な権利者に帰属します。</li>
              <li>ユーザーは本サービスを利用する権利のみを有し、いかなる権利も取得するものではありません。</li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第10条（規約変更）</h2>
            <p className="text-gray-700 leading-relaxed">
              当社は、必要に応じて本規約を改訂できるものとし、改訂後はアプリ内またはウェブサイトで公表します。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">第11条（準拠法・裁判管轄）</h2>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
              <li>本規約は日本法を準拠法とします。</li>
              <li>本サービスに関して紛争が生じた場合、当社の本店所在地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
            </ol>
          </section>
        </article>
      </main>
      <Footer />
    </>
  );
}
